/**
 * Gives the booleasn value if the element is in the viewport.
 * @param {Object} variant - The product variant object from which to retrieve color information ( like image, gradient, hexcode).
 * @param {string} element - The element to check if it is in the viewport
 * @returns {boolean} - return bool value if the element is in the viewport
 **/
export const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
};

export const getDisplayPrice = (price, convert = true, fractionDigits = 2) => {
  const currency = window.globalConfig.currency;
  const localeCode = window.globalConfig.localeCode;

  const options = {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  };

  if (convert) {
    price = price / 100;
  }

  const formattedPrice = new Intl.NumberFormat(localeCode, options).format(
    price,
  );

  return formattedPrice;
};
